jQuery( document ).ready(function() {

    if($('.youtube-lazy').length > 0) {
    
        $('.youtube-lazy').lazyTube();
    }

    var owl = $(".slider_video");
    owl.owlCarousel({
        items: 1,
        dots: false,
        navContainer: '.slider_aibl_customNav',
        nav : true, 
        loop : false, 
        addClassActive : true,
        onInitialized: function (event) {
            $('.slider_video').find('.owl-item').attr('aria-selected','false');
            $('.slider_video').find('.owl-item.active').attr('aria-selected','true'); // let screen readers know an item is active

            $('.slider_video').find('.owl-prev').attr('role','button').attr('title','Previous');
            $('.slider_video').find('.owl-next').attr('role','button').attr('title','Next');
            $('.owl-prev, .owl-next').attr('tabindex','0');

            
            $(document).on('keydown', function(e){

                var $focusedElement = $(document.activeElement),
                    singleOwl = $(".slider_video"),
                    type = e.which == 39? 'next': null,
                    type = e.which == 37? 'prev': type,
                    type = e.which == 13? 'enter':type;

                // if the carousel is focused, use left and right arrow keys to navigate
                if($focusedElement.hasClass('class') === 'slider_video'){

                    if (type == 'next') {
                        singleOwl.next();
                    } else if (type == 'prev') {
                        singleOwl.prev();
                    }

                    // if the prev and next buttons are focused, catch "Enter" and navigate in the right direction
                } else if (type == 'enter') {
                    if ($focusedElement.hasClass('owl-next')) {
                        singleOwl.next();
                    } else if ($focusedElement.hasClass('owl-prev')) {
                        singleOwl.prev();
                    }
                }
            });
        },
        // let screen readers know which slide is active after navigation or reinit
        onChange : function() {
            $('.slider_video').find('.owl-item').attr('aria-selected','false');
            $('.slider_video').find('.owl-item.active').attr('aria-selected','true');
        }
    });
    
});